<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">All Products</h2>
              <h2 class="listing-page-desc">Plans</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
        <div class="container-fluid ib-acquisition-bg">
          <div class="container ib-p-0">
            <div class="container multistep-box">
              <!-- flower for box -->
              <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" />
              <!-- flower for box -->
              <div class="panel panel-default" style="padding-bottom:60px">
                <div class="panel-heading active" role="tab" id="popularProducts" v-if="showPopular">
                  <div class="collapsible-link">
                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#popularProductsAccordion" aria-expanded="false" aria-controls="popularProductsAccordion">
                      Popular Products
                      <span class="plus-icon">&plus;</span>
                      <span class="minus-icon">&minus;</span>
                    </a>
                  </div>
                </div>
                <div id="popularProductsAccordion" class="panel-collapse collapse in" role="tabpanel" v-if="showPopular">
                  <div class="panel-body">
                    <div class="responsive-flex">
                      <div class="in-subclass-responsive-fix" v-for="(subClass, index) in popularSubclasses" :key="'popularSubclasses' + index">
                        <div class="item-box" v-if="subClass.category.length < 1"
                             @click="startAcquisition(subClass.class_id, 0, '', subClass.id)">
                          <img class="img-fluid" alt="icon" :src="subClass.logo" />
                          <h4 class="item-title">{{ subClass.name }}</h4>
                        </div>
                        <div v-else class="responsive-flex">
                          <div class="item-box" v-for="(category, index) in subClass.category" :key="'popularSubclassesCategory' + index"
                               @click="startAcquisition(subClass.class_id, 1, category.id, subClass.id)">
                            <img class="img-fluid" alt="icon" :src="subClass.logo" />
                            <h4 class="item-title">{{ subClass.name }}</h4>
                            <span class="item-desc">{{ category.name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-for="(mainClass, index) in mainClasses" :key="'class' + index">
                  <div class="panel-heading active" role="tab" :id="'headingOne' + index">
                    <div class="collapsible-link">
                      <a role="button" data-toggle="collapse" data-parent="#accordion" :href="'#mainClassesProductsAccordion' + index"
                        aria-expanded="false" :aria-controls="'mainClassesProductsAccordion' + index">
                        {{mainClass.name}}
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div :id="'mainClassesProductsAccordion' + index" class="panel-collapse collapse in" role="tabpanel">
                    <div class="panel-body">
                      <div class="responsive-flex" v-if="mainClass.has_category == 0">
                      <div class="item-box" v-for="(subClass, index) in mainClass.sub_classes" :key="'subclass' + index" @click="startAcquisition(mainClass.id, mainClass.has_category, '', subClass.subclass_id)">
                        <img class="img-fluid" alt="icon" :src="subClass.logo" />
                        <h4 class="item-title">{{ subClass.name }}</h4>
                      </div>
                    </div>
                      <div class="responsive-flex" v-if="mainClass.has_category == 1">
                        <div class="in-subclass-responsive-fix" v-for="(category, index) in mainClass.categories" :key="'category' + index">
                          <div class="item-box" v-for="(subClass, index) in category.sub_classes" :key="'subclass' + index" @click="startAcquisition(mainClass.id, mainClass.has_category, category.id, subClass.subclass_id)">
                            <img class="img-fluid" alt="icon" :src="subClass.logo" />
                            <h4 class="item-title">{{ subClass.name }}</h4>
                            <span class="item-desc">{{ category.name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading';
  import axios from "axios";

  export default {
    name: 'Products',
    data() {
      return {
        showLoader: false,
        showPopular: true,
        popularSubclasses: [],
        mainClasses: []
      }
    },
    components: {
      loading
    },
    created() {
      const self = this;
      let source = self.$route.query.utm_source;
      if(source != undefined) {
        self.showPopular = false;
        axios.defaults.headers.common['distribution'] = source;
      }
      self.getProductsData();
    },
    methods: {
      async getProductsData() {
        const self = this;
        const promises = [];
        self.showLoader = true;

        if(self.showPopular) {
          promises.push(await axios.get('get_popular_subclasses').then(function (resp) {
            if(resp.data.code == 200) {
              self.popularSubclasses = resp.data.data.subclasses;
            } else {
              self.showLoader = false;
              $toast.error(resp.data.message, { position: 'top-right' });
              return Promise.reject(resp);
            }
          }).catch(function (error) {
            self.showLoader = false;
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
            return Promise.reject(error);
          }));
        }

        promises.push(await axios.get('get_mainclasses').then(function (resp) {
          if(resp.data.code == 200) {
            self.mainClasses = resp.data.data.main_classes;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return Promise.reject(resp);
          }
        }).catch(function (error) {
          self.showLoader = false;
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
          return Promise.reject(error);
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
        });
      },
      startAcquisition(classId, hasCategory, categoryId, subClassId) {
        const self = this;
        self.$router.push({ name: 'Acquisition', params: { classId: classId, hasCategory: hasCategory, categoryId: categoryId, subClassId: subClassId, redirectFrom: 'products' } });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Products.vue